// ◉ xlVISION · Powering Business Together!
// © ExcelVision, Lda. — Braga, Portugal
// ( ·:·●●·:· ) xlVISION | Powering Business Together!
//
// ============================================================================
// 2026-10-27 · A CHAVE DE UMA JANELA ABERTA SOBRE UMA CÉLULA, UM PEDIDO OU UM INTERVALO
// ============================================================================
//
// ⚠️⚠️ As janelas são arrastáveis e não modais: com uma aberta, o planeador pode seleccionar
// outra célula e abrir o mesmo gesto. Sem `key`, o React REUTILIZA o componente — e os
// `useState` inicializados a partir das props (os dias do condutor, as datas da
// indisponibilidade, os trechos compostos, o «feito») ficavam os da célula ANTERIOR, debaixo do
// título da nova. Medido no `EditarAlocacao`: gravar mandava o condutor para os dias da viagem
// antiga na viatura nova, e o «✅ feito» da anterior aparecia na nova sem ter escrito nada.
// Com a chave, outra identidade é outra janela; a mesma identidade continua a ser a mesma.
//
// 📌 UMA formulação para todas (o estado inteiro que abriu a janela, serializado): uma chave
// escrita à mão por janela esquecia um campo, e a que o esquecesse era a que ninguém corre. A
// guarda `janelas-com-chave.test.ts` exige-a em cada montagem, com as isenções escritas.
// ⚠️ Num módulo próprio porque `Pedidos` e `Consultas` também a usam, e importá-la do `Mapa`
//    fechava um ciclo de importação.
// ============================================================================

/** A identidade que abriu a janela, como texto estável — `''` para o que não se serializa. */
export function chaveDaJanela(alvo: unknown): string {
  return JSON.stringify(alvo) ?? '';
}
